export default {
  title: "Additional Info",
  update: "Last Update:",
  cost: "Incidence Cost:",
  label_cost: "Incidence Cost",
  edit: "Edit",
  unspecified: "--",
};
